<template>
  <div class="information">
    <page-header title="Информация" />
    <div class="public-container public-container-mobile">
      <public-service-links-grid
        id="client"
        :title="content.blocks?.client.title"
        :items="clientItems"
        title-icon-url="/svg/vz-person.svg"
        class="mt-70"
        text-only
      />
      <public-service-links-grid
        id="develop"
        :title="content.blocks?.develop.title"
        :items="developItems"
        title-icon-url="/svg/vz-gear.svg"
        class="mt-110 mb-110"
        text-only
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import PublicServiceLinksGrid from '~/components/public/public-service-links-grid.vue'
import {getPageContent} from '~/api/content';

const content = await getPageContent('/information')

const clientItems = computed(() => [
  {
    title: content.blocks?.client.helpTitle,
    text: content.blocks?.client.helpText,
    link: {
      to: '/help/'
    }
  },
  {
    title: content.blocks?.client.tariffsTitle,
    text: content.blocks?.client.tariffsText,
    link: {
      to: '/tariffs/'
    }
  },
  {
    title: content.blocks?.client.scheduleTitle,
    text: content.blocks?.client.scheduleText,
    link: {
      to: '/run-schedule/'
    }
  },
  {
    title: content.blocks?.client.paymentTitle,
    text: content.blocks?.client.paymentText,
    link: {
      to: '/payment-methods/'
    }
  },
  {
    title: content.blocks?.client.documentTitle,
    text: content.blocks?.client.documentText,
    link: {
      to: '/documents/'
    }
  },
  {
    title: content.blocks?.client.franchiseTitle,
    text: content.blocks?.client.franchiseText,
    link: {
      to: '/franchise/'
    }
  },
  {
    title: content.blocks?.client.partnersTitle,
    text: content.blocks?.client.partnersText,
    link: {
      to: 'https://vozovoz.partners/'
    }
  },
  {
    title: content.blocks?.client.lkTitle,
    text: content.blocks?.client.lkText,
    link: {
      to: '/guide-lk/'
    }
  },
  {
    title: content.blocks?.client.mobileTitle,
    text: content.blocks?.client.mobileText,
    link: {
      to: '/mobile-application/'
    }
  },
])

const developItems = computed(() => [
  {
    title: content.blocks?.develop.iframeTitle,
    text: content.blocks?.develop.iframeText,
    link: {
      to: '/dev/iframe/'
    }
  },
  {
    title: content.blocks?.develop.apiTitle,
    text: content.blocks?.develop.apiText,
    link: {
      to: '/dev/api/'
    }
  }
])
</script>


<style lang="scss" scoped>
.information {
  .public-service-links-grid {
    &:first-child {
      @media screen and (max-width: $pub-sm) {
        margin-top: 50px;
      }
    }

    &:last-child {
      @media screen and (max-width: $pub-md) {
        margin-top: 90px;
        margin-bottom: 90px;
      }

      @media screen and (max-width: $pub-sm) {
        margin-top: 70px;
        margin-bottom: 70px;
      }
    }
  }
}
</style>